import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as employeeApi from '../../lib/api/employee';

//학교
const [
  LIST_CAREER_SCHOOL,
  LIST_CAREER_SCHOOL_SUCCESS,
  LIST_CAREER_SCHOOL_FAILURE,
] = createRequestActionTypes('employee/LIST_CAREER_SCHOOL');

export const listCareerSchool = createAction(
  LIST_CAREER_SCHOOL,
  (params) => params,
);
const listCareerSchoolSaga = createRequestSaga(
  LIST_CAREER_SCHOOL,
  employeeApi.getResumeByEmp,
);

const UNLOAD_CAREER_SCHOOL = 'employee/UNLOAD_CAREER_SCHOOL';
export const unloadCareerSchool = createAction(UNLOAD_CAREER_SCHOOL);

//가족정보
const [LIST_FAMILY_INF, LIST_FAMILY_INF_SUCCESS, LIST_FAMILY_INF_FAILURE] =
  createRequestActionTypes('employee/LIST_FAMILY_INF');

export const listFamilyInfo = createAction(LIST_FAMILY_INF, (params) => params);
const listFamilyInfoSaga = createRequestSaga(
  LIST_FAMILY_INF,
  employeeApi.getResumeByEmp,
);

const UNLOAD_FAMILY_INF = 'employee/UNLOAD_FAMILY_INF';
export const unloadFamilyInfo = createAction(UNLOAD_FAMILY_INF);


//부서이력정보
const [LIST_DEPART_INF, LIST_DEPART_INF_SUCCESS, LIST_DEPART_INF_FAILURE] =
  createRequestActionTypes('employee/LIST_DEPART_INF');

export const listDepartInfo = createAction(LIST_DEPART_INF, (params) => params);

const listDepartInfoSaga = createRequestSaga(
  LIST_DEPART_INF,
  employeeApi.getResumeByEmp,
);

const UNLOAD_DEPART_INF = 'employee/UNLOAD_DEPART_INF';
export const unloadDepartInfo = createAction(UNLOAD_DEPART_INF);


// 승진 승급 사항
const UNLOAD_PROMOTION_INF = 'employee/UNLOAD_PROMOTION_INF';
export const unloadPromotionInfo = createAction(UNLOAD_PROMOTION_INF);

const [LIST_PROMOTION_INF, LIST_PROMOTION_INF_SUCCESS, LIST_PROMOTION_INF_FAILURE] =
  createRequestActionTypes('employee/LIST_PROMOTION_INF');

export const listPromotionInfo = createAction(LIST_PROMOTION_INF, (params) => params);

const listPromotionInfoSaga = createRequestSaga(
  LIST_DEPART_INF,
  employeeApi.getResumeByEmp,
);

// 이력사항
const [LIST_RESUME_INF, LIST_RESUME_INF_SUCCESS, LIST_RESUME_INF_FAILURE] =
  createRequestActionTypes('employee/LIST_RESUME_INF');

export const listResume = createAction(LIST_RESUME_INF, (params) => params);
const listResumeSaga = createRequestSaga(
  LIST_RESUME_INF,
  employeeApi.getResumeByEmp,
);

const UNLOAD_RESUME_INF = 'employee/UNLOAD_RESUME_INF';
export const unloadResume = createAction(UNLOAD_RESUME_INF);



//기타사항
const [
  LIST_ETC,
  LIST_ETC_SUCCESS,
  LIST_ETC_FAILURE,
] = createRequestActionTypes('employee/LIST_ETC');

export const listEtc = createAction(
  LIST_ETC,
  (params) => params,
);
const listEtcSaga = createRequestSaga(
  LIST_ETC,
  employeeApi.getResumeByEmp,
);

const UNLOAD_ETC = 'employee/UNLOAD_ETC';
export const unloadEtc = createAction(UNLOAD_ETC);


export function* employeePersonalSaga() {
  yield takeLatest(LIST_RESUME_INF, listResumeSaga);
  yield takeLatest(LIST_PROMOTION_INF, listPromotionInfoSaga);
  yield takeLatest(LIST_DEPART_INF, listDepartInfoSaga);
  yield takeLatest(LIST_CAREER_SCHOOL, listCareerSchoolSaga);
  yield takeLatest(LIST_FAMILY_INF, listFamilyInfoSaga);
  yield takeLatest(LIST_ETC, listEtcSaga);
}

const initialState = {
  careerShools: null,
  careerShoolsError: null,
  familyInfo: null,
  familyInfoError: null,
  etcs: null,
  etcsError: null,
};

const employeePersonal = handleActions(
  {
    [LIST_CAREER_SCHOOL_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      careerShools: data.list.map((license) => ({
        id: license.infoUuid,
        infoUuid: license.infoUuid,
        usrUuid: license.usrUuid,
        infoTyp: license.infoTyp,
        attrVal1: license.attrVal1,
        attrVal2: license.attrVal2,
        attrVal3: license.attrVal3,
        attrVal4: license.attrVal4,
        crtNm: license.crtNm,
        crtDt: license.crtDt,
        cngNm: license.cngNm,
        cngDt: license.cngDt,
      })),
      careerShoolsError: null,
    }),
    [LIST_CAREER_SCHOOL_FAILURE]: (state, { payload: error }) => ({
      ...state,
      careerShoolsError: error,
    }),
    [UNLOAD_CAREER_SCHOOL]: (state) => ({
      ...state,
      careerShools: null,
      careerShoolsError: null,
    }),

    [LIST_DEPART_INF_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      depart: data.list.map((license) => ({
        id: license.infoUuid,
        infoUuid: license.infoUuid,
        usrUuid: license.usrUuid,
        infoTyp: license.infoTyp,
        attrVal1: license.attrVal1,
        attrVal2: license.attrVal2,
        attrVal3: license.attrVal3,
        crtNm: license.crtNm,
        crtDt: license.crtDt,
        cngNm: license.cngNm,
        cngDt: license.cngDt,
      })),
      departError: null,
    }),
    [LIST_DEPART_INF_FAILURE]: (state, { payload: error }) => ({
      ...state,
      departError: error,
    }),
    [UNLOAD_DEPART_INF]: (state) => ({
      ...state,
      depart: null,
      departError: null,
    }),

    [LIST_PROMOTION_INF_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      promotion: data.list.map((license) => ({
        id: license.infoUuid,
        infoUuid: license.infoUuid,
        usrUuid: license.usrUuid,
        infoTyp: license.infoTyp,
        attrVal1: license.attrVal1,
        attrVal2: license.attrVal2,
        attrVal3: license.attrVal3,
        crtNm: license.crtNm,
        crtDt: license.crtDt,
        cngNm: license.cngNm,
        cngDt: license.cngDt,
      })),
      promotionError: null,
    }),
    [LIST_PROMOTION_INF_FAILURE]: (state, { payload: error }) => ({
      ...state,
      promotionError: error,
    }),
    [UNLOAD_PROMOTION_INF]: (state) => ({
      ...state,
      promotion: null,
      promotionError: null,
    }),

    [LIST_RESUME_INF_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      resume: data.list.map((license) => ({
        id: license.infoUuid,
        infoUuid: license.infoUuid,
        usrUuid: license.usrUuid,
        infoTyp: license.infoTyp,
        attrVal1: license.attrVal1,
        attrVal2: license.attrVal2,
        attrVal3: license.attrVal3,
        attrVal4: license.attrVal4,
        attrVal5: license.attrVal5,
        attrVal6: license.attrVal6,
        crtNm: license.crtNm,
        crtDt: license.crtDt,
        cngNm: license.cngNm,
        cngDt: license.cngDt,
      })),
      resumeError: null,
    }),
    [LIST_RESUME_INF_FAILURE]: (state, { payload: error }) => ({
      ...state,
      resumeError: error,
    }),
    [UNLOAD_RESUME_INF]: (state) => ({
      ...state,
      resume: null,
      resumeError: null,
    }),

    [LIST_FAMILY_INF_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      familyInfo: data.list.map((family) => ({
        id: family.infoUuid,
        infoUuid: family.infoUuid,
        usrUuid: family.usrUuid,
        infoTyp: family.infoTyp,
        attrVal1: family.attrVal1,
        attrVal2: family.attrVal2,
        attrVal3: family.attrVal3,
        attrVal4: family.attrVal4,
        crtNm: family.crtNm,
        crtDt: family.crtDt,
        cngNm: family.cngNm,
        cngDt: family.cngDt,
      })),
      familyInfoError: null,
    }),
    [LIST_FAMILY_INF_FAILURE]: (state, { payload: error }) => ({
      ...state,
      familyInfoError: error,
    }),
    [UNLOAD_FAMILY_INF]: (state) => ({
      ...state,
      familyInfo: null,
      familyInfoError: null,
    }),

    [LIST_ETC_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      etcs: data.list.map((rp) => ({
        id: rp.infoUuid,
        infoUuid: rp.infoUuid,
        usrUuid: rp.usrUuid,
        infoTyp: rp.infoTyp,
        attrVal1: rp.attrVal1,
        attrVal2: rp.attrVal2,
        attrVal3: rp.attrVal3,
        attrVal4: rp.attrVal4,
        attrVal5: rp.attrVal5,
        attrVal6: rp.attrVal6,
        crtNm: rp.crtNm,
        crtDt: rp.crtDt,
        cngNm: rp.cngNm,
        cngDt: rp.cngDt,
      })),
      etcsError: null,
    }),
    [LIST_ETC_FAILURE]: (state, { payload: error }) => ({
      ...state,
      etcsError: error,
    }),
    [UNLOAD_ETC]: (state) => ({
      ...state,
      etcs: null,
      etcsError: null,
    }),
  },
  initialState,
);

export default employeePersonal;
